import type { GetNotificationSettings200DeliverySettings } from './getNotificationSettings200DeliverySettings';
import type { GetNotificationSettings200TypeSettings } from './getNotificationSettings200TypeSettings';

/**
 * 알림 설정 응답 데이터
 */
export type GetNotificationSettings200 = {
  /** 알림 전달 설정 */
  deliverySettings?: GetNotificationSettings200DeliverySettings;
  /** 알림 유형별 설정 */
  typeSettings?: GetNotificationSettings200TypeSettings;
  /** 사용자 ID */
  userId: number;
};
